import {
  AdvancedMarker,
  APIProvider,
  Map,
  Pin,
  InfoWindow,
} from '@vis.gl/react-google-maps';
import React, { useState, useEffect } from 'react';

import { ERoute } from '../types/enums/ERoute';
import { EUrlSearchParam } from '../types/enums/EUrlSearchParam';
import mapOptions from './mapOptions';
import currentLanguage from './sulu/currentLanguage';
import { googleMapsApiKey } from './sulu/geocoding';

interface IGoogleMapProps {
  addresses: string[];
  mapCenter: google.maps.LatLngLiteral;
}

// Define the shape of a Point of Interest (POI)
interface Poi {
  key: string;
  location: google.maps.LatLngLiteral;
  address: string;
}

const GoogleMap = ({ addresses, mapCenter }: IGoogleMapProps) => {
  const [geoLocations, setGeoLocation] = useState<Poi[]>([]);
  const [selectedPoi, setSelectedPoi] = useState<Poi | null>(null);

  // Geocoding for all addresses
  useEffect(() => {
    setGeoLocation([]); // <--- Add this line to clear geoLocations at the start of each addresses change
    addresses.forEach(address => {
      const [lat, lng, ...rest] = address.split(', ');
      const location = { lat: parseFloat(lat), lng: parseFloat(lng) };
      setGeoLocation(prevGeoLocations => [
        ...prevGeoLocations,
        { key: address, location, address: rest.join(', ') },
      ]);
    });
  }, [addresses]); // Dependency array: this effect runs when 'addresses' changes

  if (!mapCenter) return <p>Lade Karte...</p>;

  return (
    <div
      style={{
        height: '100%',
        minHeight: '200px',
        width: '100%',
        borderRadius: '8px',
        //  overflow: 'hidden',
      }}
    >
      <APIProvider apiKey={googleMapsApiKey}>
        <Map
          defaultZoom={12}
          center={mapCenter || { lat: 54.0885, lng: 10.133 }}
          mapId='7cfbc4bf44e5f81e'
          {...mapOptions}
          onClick={() => setSelectedPoi(null)}
        >
          {mapCenter && (
            <AdvancedMarker
              key='mapCenter'
              position={mapCenter}
              /* onClick={() =>
                            setSelectedPoi({
                              key: 'mapCenter',
                              location: mapCenter,
                              address: '',
                            })
                          } */
            >
              <Pin
                background='#066EBA'
                glyphColor='white'
                borderColor='white'
              />
            </AdvancedMarker>
          )}

          {geoLocations.map(poi => (
            <AdvancedMarker
              key={poi.key}
              position={poi.location}
              onClick={() => setSelectedPoi(poi)}
            >
              <Pin
                background='#ff9821'
                glyphColor='white'
                borderColor='white'
              />
            </AdvancedMarker>
          ))}

          {selectedPoi && (
            <InfoWindow
              position={mapCenter}
              onCloseClick={() => setSelectedPoi(null)}
              pixelOffset={[0, 100]}
            >
              <div className='h-full p-2 flex flex-col justify-between'>
                {selectedPoi.key === 'mapCenter' ? (
                  <p className='whitespace-pre-line'>{selectedPoi.address}</p>
                ) : (
                  <div>
                    <p className='mb-2 whitespace-pre-line'>
                      {selectedPoi.address
                        .replace(/Id=\d+/, '')
                        .replace(/_/g, ' - ')
                        .split(', ')
                        .filter(part => !part.includes('Id='))
                        .map((part, index) => {
                          let content;
                          if (index === 0) {
                            content = (
                              <div>
                                <p style={{ fontWeight: 'bolder' }}>{part}</p>
                              </div>
                            );
                          } else if (index <= 2) {
                            content = (
                              <div>
                                {part}
                                <br />
                              </div>
                            );
                          } else if (index === 3) {
                            content = (
                              <div>
                                <p
                                  style={{
                                    marginTop: '1rem',
                                    fontWeight: 'bolder',
                                  }}
                                >
                                  Tätigkeitsfelder:
                                </p>
                                <div className='h-24 overflow-y-auto'>
                                  <ul
                                    style={{
                                      marginTop: '0',
                                      marginLeft: '1.6rem',
                                    }}
                                  >
                                    {part.split(',').map(field => (
                                      <li key={field.trim()} className='m-0'>
                                        {field}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            );
                          } else {
                            content = null;
                          }
                          return <div key={part}>{content}</div>;
                        })}
                    </p>
                    {selectedPoi.address.match(/Id=(\d+)/) && (
                      <a
                        href={`/${currentLanguage}/${
                          ERoute.CONSULTANT_PROFILE
                        }?${EUrlSearchParam.CONSULTANT_ID}=${
                          selectedPoi.address.match(/Id=(\d+)/)?.[1]
                        }`}
                        className='text-orange-500 underline cursor-pointer self-end'
                      >
                        Profil anzeigen
                      </a>
                    )}
                  </div>
                )}
              </div>
            </InfoWindow>
          )}
        </Map>
      </APIProvider>
    </div>
  );
};

export default GoogleMap;
